// funkce pro zobrazování zvoleného zboží vloženého do košíku
// parametr - spouštěcí element '.js-...'
function CartPopUp(target) {
  var _this = this;

  //el pro funkci modal košíku
  var elPicture = $('.js-cart-popup-picture'),
    elPictureError = $('.js-cart-popup-picture-error'),
    elDiscount = $('.js-cart-popup-discount'),
    elTags = $('.js-cart-popup-tags'),
    elName = $('.js-cart-popup-name'),
    elTitle = $('.js-cart-popup-title'),
    elSubName = $('.js-cart-popup-subname'),
    elPrice = $('.js-cart-popup-price'),
    elTotalPrice = $('.js-cart-popup-total-price'),
    elTotalCount = $('.js-cart-popup-total-count'),
    elInput = $('.js-cart-popup-input'),
    elModalCta = $('.js-modal-btn-link'),
    elInfoMessage = $('.js-cart-popup-info-message'),
    elCount = $('.js-cart-popup-count'),
    elProductId = $('.js-cart-popup-product-id'),
    elProductIdHref = $('.js-cart-popup-product-id-href');

  // init modal
  var modal = new Modal();

  var cartModal = $('.js-modal-cart-popup'),
    cartModalErr = $('.js-modal-cart-popup-err');

  // target loader
  var elLoader = $('.js-modal-loader');

  // target popup status bar
  var elInfoStatusBar = $('.js-popup-info-bar');

  // uložena poslední vygenerovaná ikona (status Bar)
  var iconTmp = '';

  this.promiseAjax = function(target) {
    return new Promise(function(resolve, reject) {
      $.nette.ajax({
        url: target,
        dataType: 'json',
        success: function(result) {
          resolve(result);
        },
        error: function(err) {
          reject(err);
        }
      });
    });
  };

  this.setStatusBarWidth = function(percent) {
    if (percent >= 0 && percent <= 100) {
      elInfoStatusBar.children().css('width', percent + '%');
    }
  };

  this.showLoader = function() {
    elLoader.show();
  };
  this.hideLoader = function() {
    elLoader.hide();
  };

  // vrací cenu v závislosti jestli je akce nebo ne
  this.getPrice = function(price) {
    if (price['price_action_with_vat'] !== 0) {
      return price['price_action_with_vat'];
    } else {
      return price['price_with_vat'];
    }
  };

  // vrací html s cenou
  this.getFullPriceHtml = function(price) {
    var priceProduct = this.getPrice(price);

    // Symbol měny zdali je před nebo za cenou
    var priceSymbolLeft = '';
    var priceSymbolRight = '';
    var priceSymbolHtml =
      '<span class="price-new__currency">' + price['symbol'] + '</span>';
    var priceSymbolPosition = price['symbol_position'];

    if (priceSymbolPosition === 'left') {
      priceSymbolLeft = priceSymbolHtml;
    } else {
      priceSymbolRight = priceSymbolHtml;
    }

    // pokud je akční cena -> zobraz původní
    var priceOldHtml = '';
    if (price['price_action_with_vat'] !== 0) {
      priceOldHtml =
        '<span class="price-old">' + price['price_with_vat_format'] + '</span>';
    }

    // vypis komlet ceny
    var priceFullHtml =
      '<span class="price-new">' +
      priceSymbolLeft +
      priceProduct +
      priceSymbolRight +
      '</span>';

    return priceOldHtml + priceFullHtml;
  };

  this.getTagHtml = function(tag) {
    return (
      '<div class="tag-item" style="background-color:' +
      tag.color +
      '; color: ' +
      tag.color_text +
      ';">' +
      tag.name +
      '</div>'
    );
  };

  this.getTaglistHtml = function(tags) {
    var tagList = '';
    Object.keys(tags).forEach(function(property) {
      tagList += _this.getTagHtml(tags[property]);
    });

    return tagList;
  };

  this.fillTagList = function(tags) {
    elTags.html('');
    elTags.html(tags);
  };

  this.fillTotalPrice = function(total) {
    elTotalPrice.text('');
    elTotalPrice.text(total);
  };

  this.fillTotalCount = function(total) {
    elTotalCount.text('');
    elTotalCount.text(total);

    elInput.val(total);
    elInput.data('value',20);
  };

  this.fillName = function(name) {
    elName.text('');
    elName.text(name);
  };

  this.fillTitle = function(name) {
    elTitle.text('');
    elTitle.text(name);
  };

  this.fillSubName = function(subName) {
    elSubName.text('');
    elSubName.text(subName);
  };

  this.fillCount = function(count) {
    elCount.text('');
    elCount.text(count);
  };

  this.fillProductId = function(id, count) {
    elProductId.attr('data-input','');
    elProductId.attr('data-input',id);
    elProductId.attr('data-href','');
    elProductId.attr('data-href','/order/cart/add-to-cart?id_product='+id+ '&count='+count+'&update=1');
    //elProductId.val(1);
    elProductIdHref.attr('id','product-');
    elProductIdHref.attr('id','product-'+id);
    elProductIdHref.attr('data-href','');
    elProductIdHref.attr('data-href','/order/cart/add-to-cart?id_product='+id+ '&count='+count+'&update=1');
    elProductIdHref.attr('href','');
    elProductIdHref.attr('href','/order/cart/add-to-cart?id_product='+id+ '&count='+count+'&update=1');
  };

  this.fillPrice = function(price) {
    elPrice.html('');
    elPrice.html(price);
  };

  this.fillPhoto = function(photo) {
    elPicture.children()[0].srcset = '';
    elPicture.children()[1].src = '';
    elPicture.children()[0].srcset = photo;
    elPicture.children()[1].src = photo;
  };

  this.fillPhotoError = function(photo) {
    elPictureError.children()[0].srcset = '';
    elPictureError.children()[1].src = '';
    elPictureError.children()[0].srcset = photo;
    elPictureError.children()[1].src = photo;
  };

  this.toggleDiscount = function(price) {
    if (price.action !== 0) {
      var priceAction = price.action;
      elDiscount.text('');
      elDiscount.text('-' + priceAction + '%');
      elDiscount.show();
    } else {
      elDiscount.text('');
      elDiscount.hide();
    }
  };

  this.getInfoIconHtml = function(icon) {
    return '<div><i class="fas ' + icon + '"></i></div>';
  };
  this.getInfoMessageHtml = function(message) {
    return '<div class="info-message__text">' + message + '</div>';
  };

  this.changeInfoTypeClass = function(type) {
    elInfoMessage.removeClass('info-message--' + iconTmp);
    elInfoMessage.addClass('info-message--' + type);
    iconTmp = type;
  };

  this.changeInfoMessageHtml = function(html) {
    elInfoMessage.html('');
    elInfoMessage.html(html);
  };

  // přidat validaci když není info message
  this.fillInfoMessage = function(message) {
    if (message === null || message === undefined) {
      return;
    }
    // sestav ikonu
   // var icon = this.getInfoIconHtml(message.icon);
    var icon = this.getInfoIconHtml(message.icon);
    // sestav message
    var text = this.getInfoMessageHtml(message.message);
    // přidej class s typem
    this.changeInfoTypeClass(message.type);
    // smaz a vygeneruj komplet html
    this.changeInfoMessageHtml(icon + text);
   // this.changeInfoMessageHtml(text);
  };

  // složí vysledný produkt vložený do košíku
  this.fillProduct = function(product) {
    this.toggleDiscount(product.price);
    var price = this.getFullPriceHtml(product.price);
    this.fillPrice(price);
    this.fillTotalPrice(product.total_price);
    this.fillTotalCount(product.total_count);
    this.fillTitle(product.title);
    this.fillName(product.name);
    this.fillSubName(product.sub_name);
    this.fillCount(product.count);
    this.fillProductId(product.id, product.total_count);
    this.fillPhoto(product.foto);
    var tags = this.getTaglistHtml(product.flags);
    this.fillTagList(tags);
  };

  this.fillProductError = function(product) {
    this.toggleDiscount(product.price);
    this.fillName(product.name);
    this.fillPhotoError(product.foto);
    var tags = this.getTaglistHtml(product.flags);
    this.fillTagList(tags);
  };

  this.addToCardDataLayer = function (product) {
    var dataLayerPrice = 0; //cena bez DPH
    if (product.price['price_action'] > 0) {
      dataLayerPrice = product.price['price_action'];
    } else {
      dataLayerPrice = product.price['price'];
    }

    dataLayer.push({
      'prodid': product.id.toString(),
      'value': dataLayerPrice.toString(),
      'currency': product.currency,
      'event': 'add_to_cart',
    })
  }

  // init přidání listen event pro cílové el
  this.init = function() {


    $(document).on('click',target, function(event) {

      event.preventDefault();
      modal.showModalBg();
      _this.showLoader();
      _this
        .promiseAjax(event.currentTarget.href)
        .then(function(result) {
          if (result === undefined) {
            return;
          }
          _this.hideLoader();
          if (result.error !== undefined) {
            // zobraz err
            _this.fillProductError(result.product);
            cartModalErr.show();
          } else {
            // nastav progres
            //_this.setStatusBarWidth(result.progress);
            // nastav info o dopravě
            _this.fillInfoMessage(result.flash);
            // nastav vložený produkt
            _this.fillProduct(result.product);
            _this.addToCardDataLayer(result.product);
            cartModal.show();
            cartModal.css('display', 'flex');
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    });

    elModalCta.on('click', function() {
      window.location.href = $(this).attr('href');
    });
  };

  this.init();
}

